<!-- @veltra/icons generated sha256:d80afd641f98eb64 gen:8 source:src/svg/normal/arrow-down.svg -->
<script setup lang="ts">
defineOptions({ name: 'ArrowDown' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m3.986 6.014.01-.01a.65.65 0 0 1 .92-.007L8 9.081l3.083-3.084a.65.65 0 0 1 .92.006l.01.01a.63.63 0 0 1-.012.905l-3.649 3.649a.497.497 0 0 1-.704 0l-3.65-3.649a.63.63 0 0 1-.012-.904"
    />
  </svg>
</template>
